<template>
  <div class="modal fade" tabindex="-1" aria-labelledby="modalLabel" ref="alertRef">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content linkook-modal-box">
        <div class="linkook-modal-header">
          <h5 class="linkook-modal-title" id="modalLabel">알림</h5>
          <button type="button" class="linkook-close-btn" @click="closeAlert" aria-label="닫기">×</button>
        </div>
        <div class="linkook-modal-body">
          <div v-if="modalStore.image" class="linkook-image-wrap">
            <img :src="modalStore.image" alt="" class="linkook-modal-image" />
          </div>
          <div class="linkook-modal-message" v-html="modalStore.alertMessage"></div>
        </div>
        <div class="linkook-modal-footer">
          <button type="button" class="linkook-btn linkook-btn-primary" @click="closeAlert">확인</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Modal } from "bootstrap";
import { useModalStore } from "@/store/modal";

export default {
  data() {
    return {
      modalInstance: null,
      modalStore: useModalStore(),
      result: false,
    };
  },
  mounted() {
    this.modalInstance = new Modal(this.$refs.alertRef, { backdrop: "static" });
  },
  watch: {
    "modalStore.showAlert"(newVal) {
      if (this.modalInstance) {
        newVal ? this.modalInstance.show() : this.closeModal();
      }
    },
  },
  methods: {
    closeAlert() {
      this.modalStore.showAlert = false;
      this.result = true;
    },
    closeModal() {
      document.activeElement.blur();
      this.modalInstance.hide();
      this.$closeAlert(this.result);
    },
  },
};
</script>

<style scoped>
.linkook-modal-box {
  background: white !important;
  border: none !important;
  border-radius: 8px !important;
  width: 90%;
  max-width: 400px;
  max-height: 80vh;
  overflow-y: auto;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15) !important;
}

.linkook-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  border-bottom: 1px solid #e9ecef;
  font-style: normal;
}

.linkook-modal-title {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #333;
  font-family: "NanumSquareRoundB", sans-serif;
  font-style: normal;
}

.linkook-close-btn {
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #666;
  padding: 0;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.linkook-close-btn:hover {
  color: #333;
}

.linkook-modal-body {
  padding: 20px;
}

.linkook-image-wrap {
  display: flex;
  justify-content: center;
  margin-bottom: 16px;
}

.linkook-modal-image {
  max-width: 120px;
  max-height: 120px;
  object-fit: contain;
  border-radius: 8px;
}

.linkook-modal-message {
  white-space: pre-line;
  font-size: 14px;
  color: #333;
  line-height: 1.5;
  margin: 0;
}

.linkook-modal-footer {
  display: flex;
  gap: 10px;
  justify-content: flex-end;
  padding: 20px;
  border-top: 1px solid #e9ecef;
}

.linkook-btn {
  padding: 10px 20px;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  font-family: "NanumSquareRoundR", sans-serif;
  border: none;
}

.linkook-btn-primary {
  background: #6c757d;
  color: white;
}

.linkook-btn-primary:hover {
  background: #5a6268;
}
</style>
